import SettingRow from 'flow/components/Setting/SettingRow';
import Toggle from 'flow/components/ui-components/Toggle';
import { useWeeklySummaryEmailToggle } from 'flow/hooks/api/useAiDigestServiceSettings';
import useAppContext from 'flow/hooks/useAppContext';
import { ExtensionKey } from 'flow/types/EntityKeys';

import ToggleSkeleton from './ToggleSkeleton';

type Props = {
    extensionKey: ExtensionKey;
    disabled?: boolean;
};

const WeeklySummaryEmailSetting = ({ extensionKey, disabled }: Props) => {
    const { i18next } = useAppContext();
    const { value, onChange, loading } =
        useWeeklySummaryEmailToggle(extensionKey);

    return (
        <SettingRow
            cta={
                loading ? (
                    <ToggleSkeleton />
                ) : (
                    <div className="animate-fade-in">
                        <Toggle
                            value={value}
                            onChange={onChange}
                            disabled={disabled}
                            text={i18next.t(
                                'settings.transcriptions.call_summary.weekly_summary',
                            )}
                        />
                    </div>
                )
            }
        >
            {i18next.t('settings.transcriptions.call_summary.weekly_summary')}
        </SettingRow>
    );
};

export default WeeklySummaryEmailSetting;
